import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import { getLayouts } from '../../../store/layouts/layouts'
import { LayoutsStateType } from '../../../store/layouts/types'
import Preloader from '../../UI/Preloader/Preloader'
import ApartmentCard from './ApartmentCard/ApartmentCard'
import style from './ApartmentTable.module.scss'

const ApartmentTable = ({ projectName }: { projectName: string }) => {
  const layoutsData: LayoutsStateType = useSelector(getLayouts)
  const [itemsCount, setItemsCount] = useState<number>(8)
  const countStep = 8

  const countMax = (): boolean => {
    if (layoutsData.layouts) {
      return itemsCount >= layoutsData.layouts?.project.nav.RECORD_COUNT
    }

    return true
  }

  const getCurrentCount = () => {
    if (layoutsData.layouts) {
      const delta = layoutsData.layouts?.project.nav.RECORD_COUNT - itemsCount
      return delta < countStep ? delta : countStep
    }

    return 0
  }

  const getRemainingElements = () => {
    if (layoutsData.layouts) {
      return layoutsData.layouts?.project.nav.RECORD_COUNT - itemsCount
    }

    return 0
  }

  const handleShowMore = () => {
    if (!countMax()) {
      setItemsCount(prev => prev + countStep)
    }
  }

  return (
    <div className={style.ApartmentTable}>
      {layoutsData.pending && layoutsData.items.length === 0 ? (
        <Preloader classModifiers={['block']} />
      ) : (
        <>
          {layoutsData.items.length !== 0 ? (
            <>
              <div className={style.ApartmentTable__wrapper}>
                {layoutsData.items.map(
                  (el, index) =>
                    itemsCount >= index && (
                      <ApartmentCard
                        projectName={projectName}
                        key={el.ID}
                        ID={el.ID}
                        UF_IMAGE2D={el.UF_IMAGE2D}
                        UF_STUDIO={el.UF_STUDIO}
                        UF_AREA={el.UF_AREA}
                        UF_ROOMS={el.UF_ROOMS}
                        UF_READY_QUARTER={el.UF_READY_QUARTER}
                        isReady={el.isReady}
                        UF_PRICE={el.UF_PRICE}
                        UF_SQUARE_PRICE={el.UF_SQUARE_PRICE}
                        UF_RENOVATION={el.UF_RENOVATION}
                        UF_KORPUS={el.UF_KORPUS}
                        UF_FLOOR={el.UF_FLOOR}
                        UF_URL={el.UF_URL}
                        UF_BUILD_YEAR={el.UF_BUILD_YEAR}
                      />
                    )
                )}
              </div>
              {!countMax() && (
                <button
                  className={style.ApartmentTable__button}
                  onClick={handleShowMore}
                >
                  Показать ещё {getCurrentCount()} из {getRemainingElements()}
                </button>
              )}
            </>
          ) : (
            <h2>Нет квартир подходящих под выбор</h2>
          )}
        </>
      )}
    </div>
  )
}

export default ApartmentTable
